export enum HeaderMode {
  Default = 'default',
  Grey = 'grey',
  White = 'white',
  LightBlue = 'light-blue',
}
